// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__XWX3O","searchContent":"toolbar_searchContent__Siwu1","spacer":"toolbar_spacer__pxEE5","search":"toolbar_search__yaie7"};